import React from "react";
import KidImages from "../../PicesForPages/Purchase.webp";
import FreeConsultation from "../Form/FreeConsultation";
// import { Link } from "react-router-dom";

function purchase() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent">
        {/* Video element */}
        <img
          fetchPriority="high"
          loading="eager"
          src={KidImages}
          alt="kidImages"
          className="background-video aboutUsImage"
        />
        <div className="purchasetopBox purchasePagetopBox">
          {/* The existing Purchase span */}
          <span>Make a Purchase</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox">
            <span className="purchaseBottomLeftHeader">
              How <span className="logoBoldColor">The Mortgageist</span> Helps
              You Purchase a Home
            </span>

            <span className="purchaseBottomLeftContent">
              At <span className="logoBoldColor">The Mortgageist</span>, we
              understand that buying a home is one of the most significant
              financial decisions you will ever make. Our experienced team is
              committed to guiding you through every step of the process—whether
              you're a first-time buyer or a seasoned homeowner. We provide
              personalized mortgage solutions, expert advice on loan options,
              and a streamlined application process designed to simplify your
              path to homeownership. Our knowledgeable loan officers work
              closely with you to assess your financial situation, navigate the
              market, and secure competitive financing, ensuring you get the
              best rates and terms possible.
            </span>
            <span className="purchaseBottomLeftContent">
              In addition to personalized support, we help you prepare by
              outlining all the documentation you'll need. Being well-prepared
              not only speeds up the process but also strengthens your
              application. Here is a checklist of documents frequently required
              when purchasing a home:
            </span>

            <ul className="purchaseBottomLeftUL paperworkBottomLeftUL">
              <li>
                <b>Proof of Income:</b> Recent pay stubs or other employment
                records; if self-employed, alternative documentation such as
                bank statements or Profit & Loss statements may be required.
              </li>
              <li>
                <b>Tax Documentation:</b> Recent tax returns and related forms.
              </li>
              <li>
                <b>Bank Statements:</b> A representative sample of your checking
                and savings accounts to verify deposits and cash flow.
              </li>
              <li>
                <b>Identification:</b> Government-issued identification to
                confirm your identity.
              </li>
              <li>
                <b>Credit Information:</b> Authorizations for credit checks
                along with any supporting financial statements.
              </li>
              <li>
                <b>Property Information:</b> Documentation related to the
                property you intend to purchase, if applicable.
              </li>
            </ul>

            <span className="purchaseBottomLeftContent">
              At <span className="logoBoldColor">The Mortgageist</span>, we
              ensure you know exactly what you need from the start. Our team is
              always ready to answer your questions and help you gather the
              documentation required, making your home purchase as smooth and
              stress-free as possible. Reach out today and let us be your
              trusted partner on your route to homeownership.
            </span>
            <i className="purchaseBottomLeftContent">
              Disclaimer: This blog is for informational purposes only and does
              not constitute legal, financial, or tax advice. Please consult
              with a professional for personalized guidance
            </i>

            <div className="purchaseBottomLeftButton">
              <a
                href="https://themortgageist.my1003app.com/2692605/register/"
                target="_blank"
                rel="noreferrer"
                className="purchaseBottomLeftButtonLink"
              >
                Apply Now
              </a>
            </div>
          </div>
          <FreeConsultation />
        </div>
      </div>
    </div>
  );
}

export default purchase;
